// @flow
import { get, sortBy } from 'lodash';

import {
  CLEAR_ADDITIONAL_TRANSPORTS,
  FETCH_ADDITIONAL_TRANSPORTS,
  UPDATE_FILTERED_RESULTS,
  SORT_ADDITIONAL_TRANSPORTS,
} from 'Store/booking/additional-transports/additionalTransports.action';
import { filterDataSet } from 'Store/filters/filtersHelper';

type State = ?Array<AdditionalTransport>;

const initialState: State = null;

function filteredTransportsReducer(state: State = initialState, action: ?Action<*>): State {
  const additionalTransports = get(action, 'payload.additionalTransports') || [];
  const filters = get(action, 'payload.filters') || [];

  switch (get(action, 'type')) {
    case CLEAR_ADDITIONAL_TRANSPORTS:
    case FETCH_ADDITIONAL_TRANSPORTS:
      return initialState;

    case SORT_ADDITIONAL_TRANSPORTS:
      const sorterPath = get(action, 'payload.sorter.path');
      return sortBy(filterDataSet(additionalTransports, filters), sorterPath);

    case UPDATE_FILTERED_RESULTS:
      return filterDataSet(additionalTransports, filters);

    default:
      return state;
  }
}

export default filteredTransportsReducer;
